/**
 * DD-012 | Quick filter capsules — progressive enhancement
 *
 * The capsules are server-rendered as real filter links (see dd-quick-filters.liquid),
 * so they work with no JS at all (full-page navigation via the href). This script
 * upgrades them to instant, no-reload filtering by routing clicks through Dawn's own
 * AJAX pipeline (FacetFiltersForm.renderPage) — the same path the native filters use.
 *
 * No dependencies. Safe to load on every collection page.
 */
(function () {
  'use strict';

  var CAPSULE_SELECTOR = '.dd-qf__capsule';

  /**
   * Reflect each capsule's active state from the current URL params. This is the
   * single source of truth after any AJAX filter change (Dawn updates the URL).
   */
  function syncCapsules() {
    var params = new URLSearchParams(window.location.search);
    document.querySelectorAll(CAPSULE_SELECTOR).forEach(function (cap) {
      var name = cap.getAttribute('data-filter-name');
      var value = cap.getAttribute('data-filter-value');
      var active = params.getAll(name).indexOf(value) !== -1;
      cap.classList.toggle('dd-qf__capsule--active', active);
      cap.setAttribute('aria-pressed', String(active));
    });
  }

  /**
   * Build the target search string for toggling a capsule against the current URL.
   * Adds the value if inactive, removes it if active; resets pagination.
   */
  function buildToggledSearch(name, value) {
    var params = new URLSearchParams(window.location.search);
    var existing = params.getAll(name);
    var isActive = existing.indexOf(value) !== -1;

    params.delete(name);
    existing.forEach(function (v) {
      if (v !== value) params.append(name, v);
    });
    if (!isActive) params.append(name, value);

    params.delete('page'); // a filter change should return to page 1
    return params.toString();
  }

  function onCapsuleClick(event) {
    var cap = event.target.closest(CAPSULE_SELECTOR);
    if (!cap) return;

    // No Dawn facet engine on the page → let the link navigate normally (no-JS path).
    if (typeof FacetFiltersForm === 'undefined' || typeof FacetFiltersForm.renderPage !== 'function') {
      return;
    }

    event.preventDefault();

    var name = cap.getAttribute('data-filter-name');
    var value = cap.getAttribute('data-filter-value');
    var searchParams = buildToggledSearch(name, value);

    // Optimistic UI — flip immediately, then re-sync from the URL once Dawn renders.
    cap.classList.toggle('dd-qf__capsule--active');
    cap.setAttribute('aria-pressed', cap.classList.contains('dd-qf__capsule--active') ? 'true' : 'false');

    // Hand off to Dawn: re-renders the grid + native facets + active facets and
    // updates the URL, exactly like changing a native filter.
    FacetFiltersForm.renderPage(searchParams);
  }

  function init() {
    document.addEventListener('click', onCapsuleClick);

    // Re-sync whenever Dawn swaps the product grid (covers AJAX filter/sort/paginate
    // and browser back/forward, which Dawn handles via popstate).
    var grid = document.getElementById('ProductGridContainer');
    if (grid && typeof MutationObserver !== 'undefined') {
      new MutationObserver(syncCapsules).observe(grid, { childList: true, subtree: true });
    }
    window.addEventListener('popstate', syncCapsules);

    syncCapsules();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
